import { useEffect, useMemo, useRef } from 'react';
import { FieldChangeCallback, ValueFieldProps } from '@sitecore-jss/sitecore-jss-react-forms';

import { HiddenReferrerViewModel } from '../../types/hiddenReferrer';
import { appendCampaignParamsToUrl } from '../../utilities/campaignParamsCookie';

const HiddenReferrer: React.FC<ValueFieldProps<HiddenReferrerViewModel>> = ({
  field,
  onChange,
}) => {
  const { id, name } = field.valueField;
  const onChangeRef = useRef<FieldChangeCallback>(onChange);

  const url = useMemo(() => {
    if (typeof window === 'undefined') return '';
    try {
      return appendCampaignParamsToUrl(window.parent.location.href);
    } catch {
      return appendCampaignParamsToUrl(window.location.href);
    }
  }, []);

  useEffect(() => {
    onChangeRef.current && onChangeRef.current(name, url, true, []);
  }, [url, name]);

  return <input type="hidden" id={id} name={name} value={url} />;
};

export default HiddenReferrer;
